import React from 'react';
import { Slider } from '@mui/material';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import {
  StyledCustomThumb,
  StyledCustomTrack,
  StyledSlider,
} from './index.style';

const SliderData = ({
  valueSlider,
  onChangeSlider,
  labelMetric,
  minNumber,
  maxNumber,
  step,
}) => (
  <StyledSlider>
    <Typography variant="body-14-medium" color={COLOR.darkGray}>
      {labelMetric}
    </Typography>
    <Slider
      className="slider-mui"
      sx={{
        height: 4,
        marginLeft: '5px',
        '& .MuiSlider-track': {
          backgroundColor: 'gray',
          height: 4,
          color: '#007AFF',
        },
        '& .MuiSlider-rail': {
          backgroundColor: '#007AFF14',
          height: 4,
          opacity: 1,
        },
        '& .MuiSlider-thumb': {
          width: 16,
          height: 16,
          color: '#fff',
          background: '#fff',
          zIndex: 200,
          boxShadow: '0px 1px 4px 0px #007AFF7A',
        },
        '& .MuiSlider-thumb:before': {
          width: 12,
          height: 12,
          background: 'linear-gradient(207deg, #007AFF 2.76%, #1A37E1 80.69%)',
          zIndex: 201,
        },
        '& .MuiSlider-mark': {
          backgroundColor: 'transparent',
        },
        '& .MuiSlider-markLabel': {
          display: 'none',
        },
        '& .MuiSlider-thumb.Mui-focusVisible': {
          boxShadow: 'none',
        },
      }}
      step={step}
      min={minNumber}
      max={maxNumber}
      value={valueSlider}
      onChange={onChangeSlider}
      valueLabelDisplay="off"
      getAriaValueText={() => null}
      components={{
        Thumb: (props) => <StyledCustomThumb {...props} />,
        Track: (props) => <StyledCustomTrack {...props} />,
      }}
    />
  </StyledSlider>
);

export default SliderData;
